import axios from "../api";
import { objectToParam } from "../../libs/utils";

export async function getLocations(params = {}) {
  const parameters = objectToParam(params);
  const { data } = await axios.get("locations?" + parameters);
  return data;
}

export async function getLocation(id) {
  const { data } = await axios.get("locations/" + id);
  return data;
}

export async function createLocation(values) {
  const { data } = await axios.post("locations", values);
  return data;
}

export async function updateLocation(id, values) {
  const { data } = await axios.patch("locations/" + id, values);
  return data;
}

export async function deleteLocation(id) {
  const { data } = await axios.delete("locations/" + id);
  return data;
}
